// extracted by mini-css-extract-plugin
export var columns = "list-columns-module--columns--e7c0e";
export var listColumnHeader = "list-columns-module--listColumnHeader--35a75";
export var listColumnItem = "list-columns-module--listColumnItem--17c5a";
export var listColumnsWrapper = "list-columns-module--listColumnsWrapper--41f79";